/* Watch editions — HEllO EDC. Added 11 Oct 2026.

   WHY
   A watch edition (e.g. "GRACE in Suede For Cartier Tank") is its own product
   page — its own name, photos, copy, and sizes named after the watch's models
   — built on a base strap (GRACE in Suede). It is the same physical strap, so
   it must sell the base strap's variant: one SKU and one stock count in
   Shopify and in FYND, whichever page the customer bought from.

   WHAT IT DOES
   At Add to cart, before anything else runs (window, capture phase — ahead of
   wc-cart.js, which posts the strap and its buckle, and ahead of the theme's
   own product form), it:
     1. swaps the form's variant id for the base twin's;
     2. adds a visible line property, e.g.
          Edition: Cartier Tank · 20mm Large (Tank Solo / Basculante)
        so the cart, checkout, order and packing slip still say which edition
        and which model size the customer chose;
     3. adds hidden properties (_edition_handle, _edition_variant,
        _edition_title, _edition_img) so the cart drawer and order emails show
        the edition's own name and photo.
   Both are put back on the next tick, so the page keeps showing the edition.
   Works for every form on the page that posts this product's variant id
   (the main form, the sticky bar's).

   The map comes from snippets/wc-edition.liquid via the picker
   (script[data-wc-edition]). Stock shown on the page is already the base
   twin's, done in Liquid. */
(function () {
  'use strict';
  if (window.__wcEdition) return;
  window.__wcEdition = true;

  var el = document.querySelector('script[data-wc-edition]');
  if (!el) return;
  var data;
  try { data = JSON.parse(el.textContent); } catch (e) { return; }
  if (!data || !data.map) return;

  var map = data.map;                 /* edition variant id -> [base id, sellable, size note] */
  var label = data.label || '';
  var PROP = 'properties[Edition]';

  function note(row) {
    var size = row && row[2] ? String(row[2]) : '';
    return size ? label + ' · ' + size : label;
  }

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    var row = map[String(idInput.value)];
    if (!row || !row[0]) return;

    var original = idInput.value;
    idInput.value = String(row[0]);

    /* The visible note, plus two hidden ones the cart uses to show the
       edition's own name and photo (snippets/wc-edition-line.liquid). */
    var added = [];
    function addProp(name, value) {
      if (!value || form.querySelector('[name="' + name + '"]')) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
      added.push(input);
    }
    if (label) addProp(PROP, note(row));
    addProp('properties[_edition_handle]', data.handle || '');
    addProp('properties[_edition_variant]', String(original));
    /* Title and photo travel with the line too, for places that cannot look
       the edition up (order emails; GoKwik, if it can be set to read them). */
    addProp('properties[_edition_title]', data.title || '');
    addProp('properties[_edition_img]', row[3] || '');

    /* Everything that reads the form (wc-cart.js, the theme's ProductForm, a
       native post) reads it synchronously inside this same submit event. */
    setTimeout(function () {
      if (idInput.value === String(row[0])) idInput.value = original;
      added.forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    }, 0);
  }, true);
})();
